<div class="container">
  @if(uploadFiles.length === 0){
  <div class="upload-buttons">
    @if(child?.breadcrumbs.length > 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1)){
    <ion-button (click)="child?.openMoveFolderModal()"
      ><ion-icon size="small" name="folder-open-outline" slot="start"></ion-icon
      >Verschieben
    </ion-button>
    } @if(selectedNodeItems.length == 1 && state.userHasMinType(1)){
    <ion-button (click)="child?.renameFolder()"
      ><ion-icon size="small" name="create-outline" slot="start"></ion-icon
      >Bearbeiten
    </ion-button>
    } @if(selectedNodeItems.length > 0 && state.userHasMinType(1)){
    <ion-button color="danger" (click)="child?.deleteNodes()"
      ><ion-icon size="small" name="trash-outline"></ion-icon>
    </ion-button>
    } @if(currentFolder()?.id != null && selectedNodeItems.length == 0){
    <ion-button (click)="openFileInput()"
      ><ion-icon
        name="cloud-upload-outline"
        slot="start"
        size="small"
      ></ion-icon
      >Dokumente hochladen</ion-button
    >
    <input
      type="file"
      id="file"
      class="hidden"
      (change)="fileInput($any($event.target).files)"
      [accept]="state.supportedFileTypes.join(',')"
      multiple
    />
    }
    <!--ion-button
      (click)="openCamera()"
      *ngIf="selectedNodeItemId != magicNumber && selectedNodes.length == 0"
      ><ion-icon
        size="small"
        
        name="camera-outline"
      ></ion-icon>
    </ion-button-->
    @if(selectedNodeItems.length == 0 && state.userHasMinType(1)){
    <ion-button (click)="child?.addFolder()">Neuer Ordner</ion-button>
    }
  </div>
  }
  <lib-file-tree
    (selectedNodeItemsChanged)="selectedNodeItemsChanged($event)"
    (currentFolderNodeItemChanged)="currentFolderNodeItemChanged($event)"
    (openFile)="openFile($event)"
    style="width: 100%"
  ></lib-file-tree>
</div>
